// @ts-ignore
//------------------------------------------------------------
// 
// Author:    Tony Henderson
// Generator: ElevenFiftyNine Automated Tool Chain  
// Project:   https://github.com/BinaryBlox-Schedule-API
//------------------------------------------------------------

import { EntityState } from '@reduxjs/toolkit'
import { 
    DataLookupState,
    entityReducer as dataLookupReducer, 
    entityActions as dataLookupActions,
    entityRequests as dataLookupRequests,
    entityAdapterList as dataLookupEntityAdapterList,
} from './slices/DataLookup.slice';
import { 
    SchoolsState,
    entityReducer as schoolsReducer, 
    entityActions as schoolsActions,
    entityRequests as schoolsRequests,
    entityAdapterList as schoolsEntityAdapterList,
} from './slices/Schools.slice';

/**
 * Returns all reducers for given entity type. 
 * @export
 * @interface sRSFeatureReducers
 */
const sRSFeatureReducers = { 
    dataLookup: dataLookupReducer,
    schools: schoolsReducer
};

/**
 * Returns all actions for given entity type. 
 * @export
 * @interface sRSFeatureActions
 */
const sRSFeatureActions = { 
    dataLookup: dataLookupActions,
    schools: schoolsActions
};

/**
 * Returns all requests to be dispatched for a given entity type. 
 * @export
 * @interface sRSFeatureRequests
 */
const sRSFeatureRequests = { 
    dataLookup: dataLookupRequests,
    schools: schoolsRequests
};

/**
 * Returns all Entity Adapters for each respective entity. 
 * @export
 * @interface sRSFeatureRequests
 */
const sRSFeatureEntityAdapters = { 
    dataLookup: dataLookupEntityAdapterList,
    schools: schoolsEntityAdapterList
};


/**
 * Returns all state types for Tags. 
 * @export
 * @interface sRSFeatureTagStateTypes
 */
const sRSFeatureTagStateTypes = { 
    DataLookupState: 'dataLookup',
    SchoolsState: 'schools'
};


/**
 * Returns all state types for Tags entities. 
 * @export
 * @interface sRSFeatureStateTypes
 */
const sRSFeatureStateTypes = { 
    DataLookup_CountyState: 'countyEntity',
    DataLookup_DistrictState: 'districtEntity',
    DataLookup_RegionState: 'regionEntity',
    Schools_SchoolState: 'schoolEntity',
    Schools_SchoolCohortState: 'schoolCohortEntity',
    Schools_SchoolDesignatedContactState: 'schoolDesignatedContactEntity',
    Schools_SchoolInformationState: 'schoolInformationEntity',
}; 


/**
 * Feature state
 * @export
 * @interface SRSFeatureFeatureState
 */
export declare interface  SRSFeatureFeatureState { 
    dataLookupState: DataLookupState,
    schoolsState: SchoolsState
};


/**
 * Abstract ApiEntity interface to store entity data on the client.
 * @export
 * @interface ApiEntity 
 */
export declare interface ApiEntity {
    id: Number | string,
    name: string,
    description: string, 
    items: Array<any>,
    status: string,
}

/**
 * Abstract ApiEntityState interface to store entity state data on the client.
 * @export
 * @interface ApiEntityState<T> 
 */
export declare interface ApiEntityState<T> extends EntityState<T> {
    selectedEntity: any | null;
    selectedEntityId: number | string | null;
    selectedEntityTypeId: number | string | null;
    allItemsLoaded: boolean | null;
    isLoading: boolean;
    isUpdating: boolean;
    statusMessage: string;
    error: any;
}

/**
 * Core Redux values for SRSFeature feature.
 * @export
 * 
 */
export { 
    sRSFeatureReducers, 
    sRSFeatureActions, 
    sRSFeatureRequests,
    sRSFeatureEntityAdapters,
    sRSFeatureStateTypes,
    sRSFeatureTagStateTypes,
};



